import { Component, Inject, OnInit } from '@angular/core';
import { global } from '../../_nav';
import { INavData } from '@coreui/angular';
import { Router, NavigationEnd } from '@angular/router';
import { OrdenCompras } from '../../Models/ordencompras-dto';
import { Configuracion } from '../../Models/configuracion-dto';
import { ServiceLogin } from '../../servicio/ServiceLogin';
import { ServiceOrdenCompra } from '../../servicio/ServiceOrdenCompra';
import { ServiceCatalogoParametro } from '../../servicio/ServiceCatalogoParametro';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Observable } from 'rxjs/Rx';
import { Subscription } from "rxjs";
import { TimerObservable } from "rxjs/observable/TimerObservable";
import { environment } from '../../../environments/environment';
import { HubConnection } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { AngularFirestore } from '@angular/fire/firestore';

declare var $: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit {

  private _hubConnection: HubConnection | undefined;
  messages:any= [];
  diferencia:any= [];
  total_msj:number = 0;

  public sidebarMinimized = false;
  public navItems: INavData[];
  public anio: string = "";
  public modelo: OrdenCompras;
  public modeloCon: Configuracion;
  public dataSource: any = [];
  public nombreUsuario: string = "";
  public perfilUsuario: string = "";
  public proveedorUsuario: string = "";
  public empresaUsuario: string = "";
  public visiblePedido: boolean;
  public visibleNotificacion:boolean = true;
  private tick: string;
  private subscription: Subscription;
  private baseUrl:string;
  constructor(private firebase: AngularFirestore,private toastrService:ToastrService, private globalVar: global, @Inject(LOCAL_STORAGE) private storage: WebStorageService, private servicio: ServiceLogin, private router: Router, private servicioOrdenCompra: ServiceOrdenCompra, private serviceCatalogoParametro: ServiceCatalogoParametro) {
    
    this.navItems = this.globalVar.navItems;
    var usr = [];
    var conf = [];
    this.modelo = new OrdenCompras();
    this.modeloCon = new Configuracion();
    conf = this.storage.get("CONFIGURACION");
    usr = this.storage.get("USUARIO");
    this.modeloCon.con_usr_codigo = usr[0]["usr_codigo"];
    if (conf[0]["up_ordencompra"] == "true") {
      this.modeloCon.con_ordenCompras = true;
    } else {
      this.modeloCon.con_ordenCompras = false;
    }
    if (conf[0]["up_confirmacion"] == "true") {
      this.modeloCon.con_confirmacion = true;
    } else {
      this.modeloCon.con_confirmacion = false;
    }
    if (conf[0]["up_informativo"] == "true") {
      this.modeloCon.con_notificacion = true;
    } else {
      this.modeloCon.con_notificacion = false;
    }
    //this.modeloCon.con_ordenCompras = conf[0]["up_ordencompra"];
    //this.modeloCon.con_confirmacion = conf[0]["up_confirmacion"];
    //this.modeloCon.con_notificacion = conf[0]["up_informativo"];

    //setTimeout(() =>{
    //  firebase.collection("user").doc(''+this.modeloCon.con_usr_codigo).collection("notificacion")
    //    .stateChanges()
    //    .subscribe((notificacion:any) => {
    //          for(var i= 0; i < notificacion.length;i++){
    //            var data = JSON.parse(notificacion[i].data);
    //            this.toastrService.info(data.ntf_titulo,data.ntf_mensaje);
    //          }
    //    });});
  



    if (usr[0]["prv_codigo"] != null && usr[0]["prv_codigo"] != "") {
      if (this.modeloCon.con_ordenCompras == true) {
        this.visiblePedido = false;
      } else {
        this.visiblePedido = true;
      }
      this.modelo.ord_codproveedor = usr[0]["prv_codigo"];
      this.modelo.ord_nomproveedor = usr[0]["prv_nom_proveedor"];
      let timer = TimerObservable.create(2000, 10000);
      this.subscription = timer.subscribe(t => {
        this.consultaTotalOrdenCompra();
      });
    } else {
      this.visibleNotificacion = false;
      this.visiblePedido = true;
    }

    var emp = [];
    emp = this.storage.get("EMPRESA");
    this.nombreUsuario = usr[0]["usr_nombre"] + " " + usr[0]["usr_apellido_usuario"];
    this.perfilUsuario = " Perfil:" + usr[0]["nombre_pus"];
    if (emp.length > 0) {
      this.empresaUsuario = "Empresa:" + emp[0]["emp_nombre_empresa"];
    } else {
      this.empresaUsuario = "";
    }
    if (usr[0]["prv_nom_proveedor"] == "") {
      this.proveedorUsuario = "";
    } else {
      this.proveedorUsuario = " Proveedor:" + usr[0]["prv_nom_proveedor"];
    }
    this.anio = (new Date().getFullYear().toString())
  }
  ngOnInit(): void {
    this.init();
   
  }

  
 
  private init() {

    var token = this.storage.get("TOKEN");
    token =  token.substring(7,token.length);
    let tokenValue = '';
    if (token !== '') {
        tokenValue = '?token=' + token;
    }

    //this._hubConnection = new signalR.HubConnectionBuilder()
    //    .withUrl(`${environment.notificacion_server}`,{
    //      skipNegotiation: true,
    //      accessTokenFactory: () => {
    //        return token },
    //      transport: signalR.HttpTransportType.WebSockets
    //  }).withAutomaticReconnect([0, 2000, 5000, null])
    //    .configureLogging(signalR.LogLevel.None)
    //    .build();

    //this._hubConnection.start().then(()=>{
    //  let info = {
    //      empresa:  this.storage.get("EMPRESA"),
    //      connectionId: this._hubConnection.connectionId
    //  }
    //  console.log(this._hubConnection.connectionId)
    //  var emp = [];
    //  emp = this.storage.get("EMPRESA");
    //  this._hubConnection.send("SendInformacion",emp[0]["emp_codigo"]);
    //}).catch(err => console.error(err.toString()));

    //this._hubConnection.on('mensaje', (data: any) => {
    //    const received = `Received: ${data}`;
    //    if(this.messages.length > 0)
    //      this.diferencia = this.getDiferencia(data);
    //    this.messages = data.slice();
    //  //  console.log(this.messages);
    //    this.total_msj = this.messages.filter(x => x.ntf_estado!=3).length;
    //    this.showMensaje();
    //    // this._hubConnection.send("actulizar",this.diferencia);
    //});
}
Toast = this.crearToast();
Toast2 = this.crearToast();

getDiferencia(data){
  let dataTemp = data.filter(x=>moment(x.ntf_fecha).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD") && x.ntf_estado == 1);
  let mensajes = this.messages.filter(x=>moment(x.ntf_fecha).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD") && x.ntf_estado == 1);
  let diferencia = [];
  for(var i = 0; i<dataTemp.length; i++) {
    if( !(mensajes.filter(x => x.ntf_codigo == dataTemp[i].ntf_codigo).length >= 1)){
        diferencia.push(dataTemp[i]);
    }
  }
    return diferencia;
}

showMensaje(){
  if(this.diferencia.length == 1 || this.diferencia.length ==2)
  this.toastrService.info(this.diferencia[0].ntf_titulo,this.diferencia[0].ntf_mensaje)
  if(this.diferencia.length ==2)
  this.toastrService.info(this.diferencia[1].ntf_titulo,this.diferencia[1].ntf_mensaje)
}


  crearToast(){
    return  Swal.mixin({
      toast: true,
      showCloseButton:true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
  }

  marcarVisto(codigo){
    
  }

  getClassEstado(estado){
    if (estado == 1 || estado == 2) 
      return 'notification-item-no'
  }

  getTiempoMsj(fecha){
    var startTime = moment(fecha);
    var endTime = moment();
    var _duration = moment.duration(endTime.diff(startTime));

    // duration in hours
    var hours = Math.round(_duration.asHours());

    // duration in minutes
    var minutes = Math.round(_duration.asMinutes()%60);
    if(hours > 24)
      return startTime.format("YYYY-MM-DD HH:mm").toString();
    else if(hours == 0)
      return 'Hace '+minutes;
    else 
      return 'Hace '+hours +' horas y '+minutes + ' minutos'

  }

  configuracionMant(): any {
    this.serviceCatalogoParametro.getParametroConfiguracion(this.modeloCon).subscribe((results) => {
    }, err => {
    });
    
  }
  configurar(): any {
    var conf = [];
    conf = this.storage.get("CONFIGURACION");
    conf[0]["up_ordencompra"] = this.modeloCon.con_ordenCompras;
    conf[0]["up_confirmacion"] = this.modeloCon.con_confirmacion;
    conf[0]["up_informativo"] = this.modeloCon.con_notificacion;
    this.storage.remove("CONFIGURACION");
    this.storage.set("CONFIGURACION", conf);
    this.configuracionMant();
  }

  cambioOrden(): any {
    this.configurar();
    var usr = [];
    usr = this.storage.get("USUARIO");
    if (usr[0]["prv_codigo"] != null && usr[0]["prv_codigo"] != "") {
      if (this.modeloCon.con_ordenCompras == true) {
        this.visiblePedido = false;
      } else {
        this.visiblePedido = true;
      }
    } else {
      this.visiblePedido = true;
    }
  }


  consultaTotalOrdenCompra(): any {
    this.servicioOrdenCompra.getConsultaOrdenCompraPendiente(this.modelo).subscribe((results) => {
      try {
        if (results.codError.toString() === "0") {
          this.dataSource = results.root[0]
        }
      } catch (e) {
      }
    }, err => {
    });
  }

  cerrarSession() {
    this.servicio.setUsuarioLoginIn(false);
    this.storage.remove("USUARIO");
    this.storage.remove("AUTORIZA");
    this.storage.remove("TOKEN");
    this.storage.remove("AD");
    this.storage.remove("EMPRESA");
    this.storage.remove("USRID");
    this.storage.remove("ProveeParametro");
    this.router.navigate(['/']);
  }


  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
}
